
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("fVzNS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.init = void 0;

var $b987f3bc0e3aeffd$var$_jquery = $b987f3bc0e3aeffd$var$_interopRequireDefault((parcelRequire("4kMWr")));
function $b987f3bc0e3aeffd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
// =============================================================================
// Feature Flags Module
// =============================================================================
var $b987f3bc0e3aeffd$var$body = document.querySelector("body");
var $b987f3bc0e3aeffd$var$flags = [
    {
        name: "aktuell",
        value: [
            "default"
        ],
        "default": true,
        enabled: true
    },
    {
        name: "mehr a11y",
        value: [
            "v-a11y"
        ],
        "default": false,
        enabled: true
    }
];
var $b987f3bc0e3aeffd$var$excluded = "div, span, ul, ol, li, a, p, h1, h2, h3, h4, h5, h6, strong, i, button, input, textarea, select, label, table, tr, td, th, img, svg";
var $b987f3bc0e3aeffd$var$activateFlags = function activateFlags(session) {
    var div = document.createElement("div");
    div.classList.add("feature-flag-container");
    $b987f3bc0e3aeffd$var$flags.forEach(function(flag) {
        if (!flag.enabled) return;
        var btn = document.createElement("button");
        btn.dataset.val = flag.value.toString();
        btn.textContent = flag.name;
        // if (flag.default) btn.classList.add("active");
        div.appendChild(btn);
    });
    document.body.appendChild(div);
    if (session) {
        var sessionArray = session.split(",");
        sessionArray.forEach(function(sess) {
            $b987f3bc0e3aeffd$var$body.classList.add(sess);
            (0, $b987f3bc0e3aeffd$var$_jquery["default"])($b987f3bc0e3aeffd$var$excluded).addClass(sess);
        });
        document.querySelector('[data-val="'.concat(session, '"]')).classList.add("active");
    } else document.querySelector(".feature-flag-container button").classList.add("active");
    var attempts = 0;
    var _whenComplete = function whenComplete() {
        if (++attempts > 30) return;
        if (document.querySelector(".feature-flag-container")) {
            var featureFlagBtns = document.querySelectorAll(".feature-flag-container button");
            featureFlagBtns.forEach(function(btn) {
                btn.addEventListener("click", function(e) {
                    var featureFlag = this.dataset.val;
                    var featureFlags = featureFlag.split(",");
                    $b987f3bc0e3aeffd$var$flags.forEach(function(flag) {
                        flag.value.forEach(function(value) {
                            (0, $b987f3bc0e3aeffd$var$_jquery["default"])(".".concat(value)).removeClass(value);
                        });
                    });
                    sessionStorage.setItem("featureFlags", featureFlag);
                    if (featureFlag && featureFlag !== "default") featureFlags.forEach(function(fflag) {
                        $b987f3bc0e3aeffd$var$body.classList.add(fflag);
                        (0, $b987f3bc0e3aeffd$var$_jquery["default"])($b987f3bc0e3aeffd$var$excluded).addClass(fflag);
                    });
                    (0, $b987f3bc0e3aeffd$var$_jquery["default"])(".feature-flag-container .active").removeClass("active");
                    (0, $b987f3bc0e3aeffd$var$_jquery["default"])(this).addClass("active");
                });
            });
        } else setTimeout(function() {
            return _whenComplete();
        }, 400);
    };
    _whenComplete();
};
var $b987f3bc0e3aeffd$var$init = module.exports.init = function init() {
    var onBtn = document.getElementById("feature_flags_on");
    var offBtn = document.getElementById("feature_flags_off");
    var session = sessionStorage.getItem("featureFlags");
    if (session) $b987f3bc0e3aeffd$var$activateFlags(session);
    if (onBtn) onBtn.addEventListener("click", function() {
        sessionStorage.setItem("featureFlags", "default");
        $b987f3bc0e3aeffd$var$activateFlags();
    });
    if (offBtn) offBtn.addEventListener("click", function() {
        var ffContainer = document.querySelector(".feature-flag-container");
        if (ffContainer) ffContainer.remove();
        sessionStorage.removeItem("featureFlags");
    });
};

});


//# sourceMappingURL=featureFlags.module.0a19bc92.js.map
